import { render, staticRenderFns } from "./addMessage.vue?vue&type=template&id=c4b60ba6&"
import script from "./addMessage.vue?vue&type=script&lang=js&"
export * from "./addMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports